
import { Component, Prop, Vue } from 'vue-property-decorator';
import JobFilterDesktop from '~/components/website/jobs/JobFilterDesktop.vue';
import { IAvailableFilters, ISelectedFilter } from '~/store/types';

@Component({
	name: 'JobFilterWrapper',
	components: {
		JobFilterDesktop
	}
})
export default class JobFilterWrapper extends Vue {
	@Prop({ type: Object, required: true }) readonly availableFilters!: IAvailableFilters;

	@Prop({ type: Array, required: true }) readonly currentSelectedFilters!: ISelectedFilter[];

	@Prop({ type: Boolean }) readonly isCompanyPage!: boolean;

	expandedFilter = -1;

	setFilter(i: number) {
		if (this.expandedFilter === i) {
			this.expandedFilter = -1;
		} else {
			this.expandedFilter = i;
		}
	}

	mounted() {
		window.addEventListener('click', this.closeOnOutsideClick, { passive: true });
	}

	beforeDestroy() {
		window.removeEventListener('click', this.closeOnOutsideClick);
	}

	closeOnOutsideClick(event) {
		const isClickInsideElement = (this.$refs.filter as Node)?.contains(event.target);
		if (!isClickInsideElement) {
			this.expandedFilter = -1;
		}
	}
}
